/******************************************************************************************
 *	Orders Service
 ********************************************************************************************/
(function () {


  angular.module('rcCommerce.orders', []).service(
    'Orders',
    /* @ngInject */
    function (_, binkySrc2, User, $q, promiseUtils) {
      this.cancelPA = function ({
        customerId,
        customerCountry,
        contractId,
        cancellableItems,
        marketSegment
      }) {
        const payload = {
          status: 'SUBMITTED',
          type: 'REMOVE_ITEMS',
          country: customerCountry,
          'market-segment': marketSegment,
          'purchase-flow': 'ResellerConsole',
          'reference-contract-id': contractId,
          'cancelling-items': cancellableItems,
          'order-identity': {
            'owner-id': User.getID(),
            'organization-id': customerId
          }
        };

        return promiseUtils.toAngularPromise(
          binkySrc2.api.orders.cancelPA(payload)
        ).catch((err) => {
          throw err;
        });
      };

      this.createPA = function (
        customerId,
        customerCountry,
        contractId,
        orderItems,
        marketSegment,
        customerPoNumber
      ) {

        const payload = {
          status: 'SUBMITTED',
          type: 'ADD_ITEMS',
          country: customerCountry,
          'market-segment': marketSegment,
          'order-items': orderItems,
          'order-identity': {
            'owner-id': User.getID(),
            'organization-id': customerId
          },
          'reference-contract-id': contractId,
          'purchase-flow': 'ResellerConsole',
          'payment-instrument': {
            'category': 'PURCHASE_ORDER',
            'purchase-order-number': customerPoNumber
          }
        };

        return promiseUtils.toAngularPromise(
          binkySrc2.api.orders.cancelPA(payload)
        ).catch((err) => {
          throw err;
        });
      };
    }
  );
})();
